// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import AddMemberActionType from './add-member.types';
import {
	fetchExistsMemberDetailsSuccess,
	fetchExistsMemberDetailsFailure,
	fetchExistsMemberDetailsResponseChanged,
	fetchMemberDataResponseChanged,
	fetchMemberDataFailure,
	fetchMemberDataSuccess,
	getMemberMandatoryResponseChanged,
	getMemberMandatoryFailure,
	getMemberMandatorySuccess,
	fetchAddMemberListFailure,
	fetchAddMemberListSuccess,
	fetchAddMemberListResponseChanged,
	deleteMemberResponseChanged,
	deleteMemberSuccess,
	deleteMemberFailure,
	checkMandatoryFieldsFailure,
	checkMandatoryFieldsSuccess,
	checkMandatoryFieldsRespChanged,
} from './add-member.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	fetchMemberData,
	memberDetailsGetService,
	memberMandatoryGetService,
	addMemberListFetchService,
	deleteMemberService,
	checkMandateMember,
} from './add-member.service';

/** ***************** GET MEMBER DETAILS START *********************** */
export function* memberDetailsGet({ payload }: any) {
	try {
		const key = 'MemberProfileDetails';
		const { memberID, databaseName, companyID } = payload;

		const jsonData = {
			MemberID: memberID,
			DatabaseName: databaseName,
			CompanyID: companyID,
			Secratekey: key,
		};
		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberDetailsGetService, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchExistsMemberDetailsFailure(responseData.data));
		} else {
			yield put(fetchExistsMemberDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchExistsMemberDetailsFailure(error));
	}
}

export function* resetMemberDetails() {
	yield put(fetchExistsMemberDetailsResponseChanged());
}

export function* onGetMemberDetailsStart() {
	yield takeLatest(AddMemberActionType.GET_MEMBER_DETAILS_START, memberDetailsGet);
}

export function* onResetGetMemberDetails() {
	yield takeLatest(
		AddMemberActionType.GET_MEMBER_DETAILS_RESPONSE_REST_START,
		resetMemberDetails,
	);
}
/** ***************** GET MEMBER DETAILS END *********************** */

/** ***************** FETCH PARTICULAR MEMBER DETAILS START *********************** */
export function* memberDataGet({ payload }: any) {
	try {
		const key = 'FetchMemberDataKey';
		const { MemberID, databaseName, companyID } = payload;
		const jsonData = {
			MemberID,
			DatabaseName: databaseName,
			CompanyID: companyID,
			Secratekey: key,
		};
		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchMemberData, verifyData, payload.serviceName);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchMemberDataFailure(responseData.data));
		} else {
			yield put(fetchMemberDataSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchMemberDataFailure(error));
	}
}

export function* resetMemberData() {
	yield put(fetchMemberDataResponseChanged());
}

export function* onGetMemberDataStart() {
	yield takeLatest(AddMemberActionType.FETCH_PARTICULAR_MEMBER_DETAILS_START, memberDataGet);
}

export function* onResetGetMemberData() {
	yield takeLatest(
		AddMemberActionType.FETCH_PARTICULAR_MEMBER_DETAILS_RESPONSE_REST_START,
		resetMemberData,
	);
}
/** ***************** FETCH PARTICULAR MEMBER DETAILS END *********************** */

/** ***************** GET MEMBER MANDATORY FIELDS START *********************** */
export function* memberMandatoryGet({ payload }: any) {
	try {
		const key = 'MemberMandatoryDetailskey';
		const { databaseName, companyID, userID, type, UserPassword, memberID } = payload;

		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			OfficerID: userID,
			AccessType: type,
			UserPassword: UserPassword,
			MemberID: memberID,
			Secratekey: key,
		};
		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(memberMandatoryGetService, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getMemberMandatoryFailure(responseData.data));
		} else {
			yield put(getMemberMandatorySuccess(responseData.data));
		}
	} catch (error) {
		yield put(getMemberMandatoryFailure(error));
	}
}

export function* resetMemberMandatoryData() {
	yield put(getMemberMandatoryResponseChanged());
}

export function* onGetMemberMandatoryStart() {
	yield takeLatest(AddMemberActionType.GET_MEMBER_MANDATORY_FIELDS_START, memberMandatoryGet);
}

export function* onResetMemberMandatoryData() {
	yield takeLatest(
		AddMemberActionType.GET_MEMBER_MANDATORY_FIELDS_RESPONSE_REST_START,
		resetMemberMandatoryData,
	);
}
/** ***************** GET MEMBER MANDATORY FIELDS END *********************** */

/** ***************** FETCH ADD MEMBER LIST START *********************** */
export function* addMemberListFetch({ payload }: any) {
	try {
		const key = 'MemberDetailsKey';
		const {
			companyID,
			userID,
			limit,
			InputSearch,
			userRole,
			userRoleID,
			userLevel,
			userAccessBranchID,
			Status,
			databaseName,
			MemberName,
			CreatedFrom,
			CreatedTo,
			FromAge,
			ToAge,
			economicActivityID,
			groupID,
			centerID,
			branchID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			Limit: limit,
			InputSearch: InputSearch,
			UserRole: userRole,
			LoginUserRoleID: userRoleID,
			Level: userLevel,
			BranchID: userAccessBranchID,
			MemberStatus: Status,
			DatabaseName: databaseName,
			MemberName: MemberName,
			FromDate: CreatedFrom,
			ToDate: CreatedTo,
			AgeFrom: FromAge,
			AgeTo: ToAge,
			EconomicActivityID: economicActivityID,
			GroupID: groupID,
			CenterID: centerID,
			AreaID: branchID,
			Secratekey: key,
		};
		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addMemberListFetchService, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAddMemberListFailure(responseData.data));
		} else {
			yield put(fetchAddMemberListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAddMemberListFailure(error));
	}
}

export function* resetFetchAddMemberList() {
	yield put(fetchAddMemberListResponseChanged());
}

export function* onFetchAddMemberListStart() {
	yield takeLatest(AddMemberActionType.FETCH_ADD_MEMBER_LIST_START, addMemberListFetch);
}

export function* onResetFetchAddMemberList() {
	yield takeLatest(
		AddMemberActionType.FETCH_ADD_MEMBER_LIST_RESPONSE_REST_START,
		resetFetchAddMemberList,
	);
}
/** ***************** FETCH ADD MEMBER LIST END *********************** */

/** ***************** DELETE MEMBER START *********************** */
export function* deleteMemberDetails({ payload }: any) {
	try {
		const key = 'MemberDeleteKey';

		const {
			companyID,
			userID,
			MemberID,
			AreaID,
			userName,
			MemberName,
			MemberInActiveReason,
			databaseName,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			UserID: userID,
			MemberID: MemberID,
			AreaID: AreaID,
			UserName: userName,
			MemberName: MemberName,
			MemberInActiveReason: MemberInActiveReason,
			DatabaseName: databaseName,
			Secratekey: key,
		};
		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(deleteMemberService, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteMemberFailure(responseData.data));
		} else {
			yield put(deleteMemberSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteMemberFailure(error));
	}
}

export function* resetMemberDelete() {
	yield put(deleteMemberResponseChanged());
}

export function* onMemberDeleteStart() {
	yield takeLatest(AddMemberActionType.DELETE_MEMBER_START, deleteMemberDetails);
}

export function* onResetDeleteMember() {
	yield takeLatest(AddMemberActionType.DELETE_MEMBER_RESPONSE_RESET_START, resetMemberDelete);
}
/** ***************** DELETE MEMBER END *********************** */

/*************** CHECK MANDATE FIELDS START ***************** */
export function* checkMandateMemberDetails({ payload }: any) {
	try {
		const key = 'MemberMandatoryKey';
		const { databaseName, accessType, companyID, MemberID, userID } = payload;

		const jsonData = {
			DatabaseName: databaseName,
			AccessType: accessType,
			CompanyID: companyID,
			MemberID: MemberID,
			OfficerID: userID,
			Secratekey: key,
		};
		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(checkMandateMember, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(checkMandatoryFieldsFailure(responseData.data));
		} else {
			yield put(checkMandatoryFieldsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(checkMandatoryFieldsFailure(error));
	}
}

export function* resetCheckMandateMemberDetails() {
	yield put(checkMandatoryFieldsRespChanged());
}

export function* onCheckMandateStart() {
	yield takeLatest(
		AddMemberActionType.CHECK_ALL_MANDATORY_FIELDs_START,
		checkMandateMemberDetails,
	);
}

export function* onResetCheckMandate() {
	yield takeLatest(
		AddMemberActionType.CHECK_ALL_MANDATORY_FIELDs_RESET_START,
		resetCheckMandateMemberDetails,
	);
}
/*************** CHECK MANDATE FIELDS END ***************** */

export function* memberDetailsSaga() {
	yield all([
		call(onGetMemberDetailsStart),
		call(onResetGetMemberDetails),
		call(onGetMemberDataStart),
		call(onResetGetMemberData),
		call(onGetMemberMandatoryStart),
		call(onResetMemberMandatoryData),
		call(onFetchAddMemberListStart),
		call(onResetFetchAddMemberList),
		call(onMemberDeleteStart),
		call(onResetDeleteMember),
		call(onCheckMandateStart),
		call(onResetCheckMandate),
	]);
}
